export enum UserFields {
    ID = "id",
    EMAIL = "email",
    ROLE_NAME = "role",
    FIRST_NAME = "firstName",
    LAST_NAME = "lastName",
    MIDDLE_NAME = "middleName",
    PHONE = "phone",
}
